import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SystemModel, Institution, SalesRep, Chain, SalesEntityModel, AlliancePartner, Association, SalesEntityBoardingHierarchyNew } from 'app/shared/models/EvoSalesPortalModel';
import { HttpErrorResponse } from '@angular/common/http';
import { UserAlert, UserAlertUpdate } from 'app/shared/models/Alerts';
import { AnnouncementsService } from '../../announcements.service';

@Component({
    selector: 'se-boarding-modal',
    styleUrls: ['./alert-view-modal.component.scss'],
    templateUrl: 'alert-view-modal.component.html',
})
export class AlertViewComponentModal {
    bindingContext: BindingContext = new BindingContext();
    @Input() UserAlertID: number;
    @Input() referrer: string = "dropdown";

    public data: UserAlert = new UserAlert();
    public saving: boolean = false;

    constructor(private activeModal: NgbActiveModal, private annSvc: AnnouncementsService, ) {

    }
    ngOnInit() {
        this.getData();
    }

    private getData() {
        this.annSvc.GetUserAlert(this.UserAlertID).then(resp => {
            this.data = resp;
        }).catch(err => {
            //fork
        });
    }


    public markAsRead(UserAlertID: number) {
        this.annSvc.UserAlertSetViewed(UserAlertID).toPromise().then(resp => {
            this.annSvc.populateBellAlerts();
            this.activeModal.close('read');
        }).catch(resp => {
            alert('There was a problem marking this notification, please try again.');
        });
    }

}
